import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Homeheader from './components/home_header';
import Stands from './components/Stands';
import About from './components/About';
import Services from './components/Services';
import Transform from './components/Transform';
import Footer from './components/Footer';
import Credentials from './components/Credentials';
import Operating from './components/Operating';
import Principals from './components/Principals';

function App() {
  return (
    <>
    <Navbar />
    <Homeheader />
    <Stands />
    <Credentials />
    <Operating />
    <About />
    <Services />
    <Transform />
    <Principals />
    <Footer />
    </>
  );
}

export default App;